var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
function stop(handler) {
    return function (event) {
        event.stopPropagation();
        if (handler)
            handler(event);
    };
}
const StyledButton = styled.button.withConfig(testableStyledComponentConfig) `
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background-color: ${(props) => props.backgroundColor};
    transition: transform 200ms ease-in-out;

    ${(props) => !props.disabled &&
    css `
            cursor: pointer;
            &:hover {
                transform: scale(1.3);
            }
        `}
`;
export const Button = React.forwardRef((props, ref) => {
    const { onClick, onTouchStart, onMouseDown, onDoubleClick, backgroundColor = 'transparent' } = props, rest = __rest(props, ["onClick", "onTouchStart", "onMouseDown", "onDoubleClick", "backgroundColor"]);
    return (React.createElement(StyledButton, Object.assign({}, rest, { ref: ref, onClick: stop(onClick), onTouchStart: stop(onTouchStart), onMouseDown: stop(onMouseDown), onDoubleClick: stop(onDoubleClick), backgroundColor: backgroundColor })));
});
Button.displayName = 'Button';
//# sourceMappingURL=index.js.map